export default "__VITE_ASSET__CM82Dduv__"